// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.room-management-page__timeline {
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
  background: var(--ds-surface);
  border: 1px solid var(--ds-border-soft);
  border-radius: var(--ds-radius-md);
  /* react-calendar-timeline positions items with absolute left offsets: keep it LTR in RTL too. */
  direction: ltr;
}

/* The timeline needs room for its date headers; phones scroll it sideways. */
.room-management-page__timeline .react-calendar-timeline {
  min-width: 560px;
}

.room-management-page__sidebar-title {
  display: inline-block;
  margin-inline-start: var(--ds-space-2);
  margin-block-start: var(--ds-space-2);
}

/* The library's default header is bright red (#c52020); use the brand instead. */
.room-management-page__timeline .rct-header-root {
  background: var(--ds-brand-dark);
  border-bottom: 1px solid var(--ds-brand-deep);
}

.room-management-page__timeline .rct-header-root,
.room-management-page__timeline .rct-dateHeader-primary {
  color: #fff;
}

.room-management-page__timeline .rct-dateHeader {
  background: var(--ds-surface-muted);
  color: var(--ds-text-2);
  border-color: var(--ds-border-soft);
}

/* Toolbar: prev/today/next, zoom and the visible range share one wrapping row. */
.room-management-page__nav {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: var(--ds-space-2);
}

.room-management-page__range {
  overflow-wrap: anywhere;
}

.room-management-page__alert {
  margin-bottom: var(--ds-space-3);
}

.room-management-page__state {
  display: flex;
  justify-content: center;
  padding: var(--ds-space-8) var(--ds-space-4);
  background: var(--ds-surface);
  border: 1px solid var(--ds-border-soft);
  border-radius: var(--ds-radius-md);
}

.room-management-page__hint {
  display: block;
  margin-top: var(--ds-space-2);
  font-size: 0.8125rem;
}

/* Room rows: name plus a small capacity/status line. */
.room-management-page__group {
  display: flex;
  flex-direction: column;
  justify-content: center;
  height: 100%;
  line-height: 1.2;
  min-width: 0;
}

.room-management-page__group-name {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-weight: 600;
  color: var(--ds-text);
}

.room-management-page__group-meta {
  font-size: 0.75rem;
  color: var(--ds-text-muted);
}

.room-management-page__timeline .rct-sidebar .rct-sidebar-row {
  padding-inline: var(--ds-space-2);
}

/* Empty slots are clickable (they open "Add booking"). */
.room-management-page__timeline .rct-horizontal-lines .rct-hl-even,
.room-management-page__timeline .rct-horizontal-lines .rct-hl-odd {
  cursor: pointer;
}

.room-management-page__timeline .rct-item.room-management-page__booking {
  cursor: pointer;
}

.room-management-page__timeline .rct-item.room-management-page__booking .rct-item-content {
  overflow: hidden;
  text-overflow: ellipsis;
}

/* Long booking titles are clipped to their block instead of spilling across the grid. */
.room-management-page__timeline .rct-item {
  overflow: hidden;
}

.room-management-page__timeline .rct-item .rct-item-content {
  display: block;
  max-width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
`, "",{"version":3,"sources":["webpack://./src/serviceProvider/components/roomManagment/RoomManagment.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;EAChB,iCAAiC;EACjC,6BAA6B;EAC7B,uCAAuC;EACvC,kCAAkC;EAClC,gGAAgG;EAChG,cAAc;AAChB;;AAEA,6EAA6E;AAC7E;EACE,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,sCAAsC;EACtC,qCAAqC;AACvC;;AAEA,iFAAiF;AACjF;EACE,gCAAgC;EAChC,6CAA6C;AAC/C;;AAEA;;EAEE,WAAW;AACb;;AAEA;EACE,mCAAmC;EACnC,uBAAuB;EACvB,mCAAmC;AACrC;;AAEA,iFAAiF;AACjF;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,4CAA4C;EAC5C,6BAA6B;EAC7B,uCAAuC;EACvC,kCAAkC;AACpC;;AAEA;EACE,cAAc;EACd,6BAA6B;EAC7B,oBAAoB;AACtB;;AAEA,uDAAuD;AACvD;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,YAAY;EACZ,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;EACnB,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,2BAA2B;AAC7B;;AAEA;EACE,iCAAiC;AACnC;;AAEA,yDAAyD;AACzD;;EAEE,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA,wFAAwF;AACxF;EACE,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB","sourcesContent":[".room-management-page__timeline {\n  overflow-x: auto;\n  -webkit-overflow-scrolling: touch;\n  background: var(--ds-surface);\n  border: 1px solid var(--ds-border-soft);\n  border-radius: var(--ds-radius-md);\n  /* react-calendar-timeline positions items with absolute left offsets: keep it LTR in RTL too. */\n  direction: ltr;\n}\n\n/* The timeline needs room for its date headers; phones scroll it sideways. */\n.room-management-page__timeline .react-calendar-timeline {\n  min-width: 560px;\n}\n\n.room-management-page__sidebar-title {\n  display: inline-block;\n  margin-inline-start: var(--ds-space-2);\n  margin-block-start: var(--ds-space-2);\n}\n\n/* The library's default header is bright red (#c52020); use the brand instead. */\n.room-management-page__timeline .rct-header-root {\n  background: var(--ds-brand-dark);\n  border-bottom: 1px solid var(--ds-brand-deep);\n}\n\n.room-management-page__timeline .rct-header-root,\n.room-management-page__timeline .rct-dateHeader-primary {\n  color: #fff;\n}\n\n.room-management-page__timeline .rct-dateHeader {\n  background: var(--ds-surface-muted);\n  color: var(--ds-text-2);\n  border-color: var(--ds-border-soft);\n}\n\n/* Toolbar: prev/today/next, zoom and the visible range share one wrapping row. */\n.room-management-page__nav {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  gap: var(--ds-space-2);\n}\n\n.room-management-page__range {\n  overflow-wrap: anywhere;\n}\n\n.room-management-page__alert {\n  margin-bottom: var(--ds-space-3);\n}\n\n.room-management-page__state {\n  display: flex;\n  justify-content: center;\n  padding: var(--ds-space-8) var(--ds-space-4);\n  background: var(--ds-surface);\n  border: 1px solid var(--ds-border-soft);\n  border-radius: var(--ds-radius-md);\n}\n\n.room-management-page__hint {\n  display: block;\n  margin-top: var(--ds-space-2);\n  font-size: 0.8125rem;\n}\n\n/* Room rows: name plus a small capacity/status line. */\n.room-management-page__group {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  height: 100%;\n  line-height: 1.2;\n  min-width: 0;\n}\n\n.room-management-page__group-name {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  font-weight: 600;\n  color: var(--ds-text);\n}\n\n.room-management-page__group-meta {\n  font-size: 0.75rem;\n  color: var(--ds-text-muted);\n}\n\n.room-management-page__timeline .rct-sidebar .rct-sidebar-row {\n  padding-inline: var(--ds-space-2);\n}\n\n/* Empty slots are clickable (they open \"Add booking\"). */\n.room-management-page__timeline .rct-horizontal-lines .rct-hl-even,\n.room-management-page__timeline .rct-horizontal-lines .rct-hl-odd {\n  cursor: pointer;\n}\n\n.room-management-page__timeline .rct-item.room-management-page__booking {\n  cursor: pointer;\n}\n\n.room-management-page__timeline .rct-item.room-management-page__booking .rct-item-content {\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n/* Long booking titles are clipped to their block instead of spilling across the grid. */\n.room-management-page__timeline .rct-item {\n  overflow: hidden;\n}\n\n.room-management-page__timeline .rct-item .rct-item-content {\n  display: block;\n  max-width: 100%;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
